import { useMemo } from 'react';

import { Asset } from 'src/interfaces/assets.types';
import AuthService from 'src/services/api/auth.service';
import { useGetMyClassEntitlementsQuery } from 'src/store/api/retail';

type ClassesAssetsMap = Record<string, Asset[] | undefined>;

export const useClassesAssetsMap = (): {
  classesAssetsMap: ClassesAssetsMap;
  isLoading: boolean;
} => {
  const isStudent = AuthService.isStudent();

  const { data: allClassesEntitlements, isLoading } =
    useGetMyClassEntitlementsQuery(undefined, {
      skip: isStudent,
    });

  return useMemo(() => {
    const classesAssetsMap: ClassesAssetsMap = {};

    if (allClassesEntitlements) {
      allClassesEntitlements.forEach((classEntitlements) => {
        classesAssetsMap[classEntitlements.resourceKey] =
          classEntitlements.programs
            .map((program) => {
              return program.assets;
            })
            .flat();
      });
    }

    return {
      isLoading,
      classesAssetsMap,
    };
  }, [allClassesEntitlements, isLoading]);
};
